'use client';
import React, { useEffect, useState } from 'react';
import { Stack, Box, Paper, Typography, SortDirection } from '@mui/material';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';
import { useNavigate } from 'react-router-dom';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import SwitchComponent from '../../../components/SwitchComponent';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import { useSearch } from '../../../components/searchContext';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';
const Project: React.FC = () => {
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();
  const navigate = useNavigate();
  // Columns definition for the table
  const columns: any[] = [
    { field: 'name', headerName: 'Project Template Name' },
    { field: 'cost', headerName: 'Price' },
    { field: 'notes', headerName: 'Notes' },
    {
      field: 'updated',
      headerName: 'Last Updated',
      valueGetter: (value: any) =>
        new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
    },
    { field: 'creator', headerName: 'User' },
    {
      field: 'status',
      headerName: 'Active',
      disableSort: true,
      renderCell: (value: any) => (
        <SwitchComponent
          checked={value === '1'}
          value={value}
          size="small"
          color="success"
          inputProps={{ 'aria-label': 'controlled' }}
          handleInputChange={() => console.log('clickstatus')}
          name={'statuseterm'}
        />
      ),
    },
  ];

  // State variables
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<any[]>([]);
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  // Fetch  list
  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.projectsURL,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        setOrderBy('name');
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchQuery, paginate]);
  // Handle status toggle
  const handleStatus = async (row: any) => {
    const newStatus = row.status === '1' ? '0' : '1';
    try {
      const response = await HttpService.patch(
        Constants.apiURL + Constants.projectsURL,
        { status: newStatus, id: row.id },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchData();
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  // Clear form and reset state

  const handlePagination = (paginationData: any) => setPaginate(paginationData);

  return (
    <Stack>
      <Box className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <div className="mt-2">
              <Paper sx={{ width: '100%' }} className="mt-4">
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6"> Project Templates</Typography>
                  <AddButtonComponent
                    onClick={() => {
                      navigate('/data-management/project-template/Add');
                      //setDialogOpen(true);
                    }}
                    keyName="quoteaddicon"
                    label="Add New"
                  />
                </Box>
                <CustomPaginationActionsTable
                  rows={rows}
                  columns={columns}
                  totalRecords={totalRecords}
                  handlePagination={handlePagination}
                  handleRowClick={(row) =>
                    navigate(`/data-management/project-template/${row.id}`)
                  }
                  paginationModel={{
                    page: paginate.offset,
                    pageSize: paginate.limit,
                  }}
                  handleStatus={handleStatus}
                  order={order}
                  orderBy={orderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Paper>
            </div>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default Project;
